export default "__VITE_ASSET__B0NnKjh9__"